import React from 'react';
import {
  Image,
  ImageBackground,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import {createStyles} from '../../../utils/createStyles';
import LinearGradient from 'react-native-linear-gradient';
import Config from 'react-native-config';
import Icon from 'react-native-vector-icons/SimpleLineIcons';
import {useSelections} from 'ahooks';
import WebviewCustomer from '../../../components/WebviewCustomer';

type itemType = {
  icon: {
    uri: string;
  };
  activeIcon: {
    uri: string;
  };
  title: string;
  component: () => React.JSX.Element;
};

const items: Array<itemType> = [
  {
    icon: require('../../../assets/images/userCenter/yinsi.png'),
    activeIcon: require('../../../assets/images/userCenter/yinsi-active.png'),
    title: '隐私政策',
    component: YinSiHtmlDocumentRender,
  },
  {
    icon: require('../../../assets/images/userCenter/fuwu.png'),
    activeIcon: require('../../../assets/images/userCenter/fuwu-active.png'),
    title: '服务协议',
    component: FuWuHtmlDocumentRender,
  },
];

export default function AboutOnePad() {
  const {select, isSelected, selected, unSelectAll} = useSelections(
    items.map((i, index) => index),
    [0],
  );
  const ContentComponent = items[selected[0]].component;

  return (
    <ImageBackground
      source={require('../../../assets/images/userCenter/bg.png')}
      style={styles.viewWrap}>
      <View style={styles.selectWrap}>
        <Image
          style={styles.logo}
          source={require('../../../assets/images/logo.png')}
        />
        <View style={styles.versionName}>
          <Text>爱学一派 · V{Config.VERSION_NAME}</Text>
        </View>
        {items.map((item, index) => (
          <TouchableOpacity
            key={item.title}
            activeOpacity={0.6}
            onPress={() => {
              unSelectAll();
              select(index);
            }}
            style={[
              styles.itemWrap,
              isSelected(index) ? {backgroundColor: '#6658FF'} : null,
            ]}>
            <View style={styles.itemWrapView}>
              <Image
                style={styles.itemWrapImg}
                source={isSelected(index) ? item.activeIcon : item.icon}
              />
              <Text
                style={[
                  styles.itemText,
                  isSelected(index) ? {color: '#fff'} : null,
                ]}>
                {item.title}
              </Text>
            </View>
            <Icon
              color={isSelected(index) ? '#fff' : '#333333'}
              size={16}
              name="arrow-right"
            />
          </TouchableOpacity>
        ))}
      </View>
      <LinearGradient
        colors={['rgba(120, 109, 255, 0)', '#786DFF', 'rgba(120, 109, 255, 0)']}
        start={{x: 0.0, y: 0.0}}
        end={{x: 0.0, y: 1.0}}
        locations={[0, 0.52, 1]}
        style={styles.lineSplit}
      />
      <View style={styles.contentWrap}>
        <ContentComponent />
      </View>
    </ImageBackground>
  );
}

export function YinSiHtmlDocumentRender() {
  return (
    <View style={HtmlDocumentStyle.WebviewWrap}>
      <WebviewCustomer
        skipToken
        url={
          'https://weixin.zijinshe.com/cms/webapp/classroom/web/publicSource/yinsi.html'
        }
      />
    </View>
  );
}

export function FuWuHtmlDocumentRender() {
  return (
    <View style={HtmlDocumentStyle.WebviewWrap}>
      <WebviewCustomer
        skipToken
        url="https://weixin.zijinshe.com/cms/webapp/classroom/web/publicSource/fuwu.html"
      />
    </View>
  );
}

const HtmlDocumentStyle = createStyles({
  WebviewWrap: {
    backgroundColor: '#fff',
    paddingHorizontal: '3.35rem',
    flex: 1,
  },
});

const styles = createStyles({
  viewWrap: {
    flex: 1,
    flexDirection: 'row',
  },
  selectWrap: {
    flex: 933,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: '22rem',
    height: undefined,
    aspectRatio: 1322 / 383,
  },
  versionName: {
    marginBottom: '7rem',
  },
  itemWrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '35rem',
    height: '5.7rem',
    borderRadius: '1rem',
    backgroundColor: '#fff',
    paddingLeft: '2.2rem',
    paddingRight: '2.5rem',
    marginBottom: '2rem',
  },
  itemWrapView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemWrapImg: {
    width: '2.5rem',
    height: '2.5rem',
    marginRight: '1.5rem',
  },
  itemText: {
    fontSize: '1.55rem',
    color: '#333333',
  },
  lineSplit: {
    width: 1,
    height: '100%',
  },
  contentWrap: {
    flex: 1075,
    backgroundColor: '#fff',
  },
});
